import React, { Fragment, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import SectionCard from '../shared/SectionCard'
//import './style.css'
import { generator } from '@/utils/NumbersUtils'
import { FileUploadField } from '../shared'
import ImgPopup from '@/components/popups/imgPopup'
import { useEffect } from 'react'
import { CRRender, Image } from '@/components/crRender'
import placeholderImg from '@/assets/images/Not_available.jpg'
import FileDocRow from './fileDocRow'

const DocsFilesNames = ["commercialRegistration", "taxCard", "hospitalLicense"]

const ProviderDocs = ({ formHandler, providerInfo }) => {
  const { t } = useTranslation()
  const [files, setFiles] = useState([])

  const updateTechnology = (name, field, value) => {
    const updatedFiles = files.map(file =>
      file.name === name ? { ...file, [field]: value[0] } : file
    )
    setFiles(updatedFiles)
    formHandler.handleFormValues('providerDocs', updatedFiles)
  }

  useEffect(() => {

    let  filesData = providerInfo?.files?.filter(f => DocsFilesNames.includes(f.name)) || []
    let  notExistFiles= DocsFilesNames.filter(f => !filesData?.map(ele=>ele.name).includes(f)).map(f => ({name: f, data: []}))|| []

    let Files = [...filesData, ...notExistFiles]

    setFiles(Files)
    formHandler.handleFormValues('providerDocs', Files)
  }, [providerInfo])



  return (
    <SectionCard
      title={t("provider-docs")}
      icon="material-icon-theme:folder-docs"
      className="edit-advanced-techs"
    >
      <div className="advanced-techs-container">

        <div className="row">
          {files.mapWithKey((docInfo, i) =>
            <Fragment key={docInfo.name}>
              <FileDocRow docInfo={docInfo} updateTechnology={updateTechnology} />
            </Fragment>
          )}

        </div>
      </div>
    </SectionCard >
  )
}

export default ProviderDocs

